module.exports = __webpack_public_path__ + "fonts/materialdesignicons-webfont.6d44375.eot";